<template>
  <div
    class="login"
    :style="pageBackgroundStyle"
  >
    <div v-if="bgImage" class="login__veil" aria-hidden="true" />
    <div class="login-page">
      <!-- 默认背景见全局 :root + .login；后台 loginImage 时由 pageBackgroundStyle 覆盖，并叠 login__veil -->
      <aside class="login-brand">
        <div class="login-brand__overlay" />
        <div class="login-brand__content">
          <h1 class="login-brand__title">智慧乐园 高效运营</h1>
          <p class="login-brand__subtitle">游乐园票务与园区业务一体化管理平台</p>
        </div>
      </aside>

      <main class="login-panel">
        <el-form
          ref="loginForm"
          class="login-card"
          :model="loginForm"
          :rules="fieldRules"
        >
          <header class="login-card__head">
            <div class="login-card__brand">
              <img class="login-card__logo" :src="getLogoImage()" alt="">
              <span class="login-card__name">{{ getSystemTitle() }}</span>
            </div>
          </header>

          <el-form-item v-if="itssusList" prop="loginTissueId" class="login-field">
            <div class="login-input-wrap">
              <i class="el-icon-menu login-field__icon login-field__icon--select" />
              <el-select
                v-model="loginForm.loginTissueId"
                class="login-select-block"
                filterable
                placeholder="请选择组织"
                @visible-change="v => v && getOptions(loginForm.username)"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.tissueName"
                  :value="item.id"
                />
              </el-select>
            </div>
          </el-form-item>

          <el-form-item prop="username" class="login-field">
            <el-input
              v-model="loginForm.username"
              type="text"
              clearable
              placeholder="用户名"
              @blur="getOptions(loginForm.username)"
            >
              <i slot="prefix" class="el-icon-user login-field__icon" />
            </el-input>
          </el-form-item>

          <el-form-item prop="password" class="login-field">
            <el-input
              v-model="loginForm.password"
              type="password"
              clearable
              placeholder="密码"
              show-password
              @keyup.enter.native="loading ? null : handleLogin()"
            >
              <i slot="prefix" class="el-icon-lock login-field__icon" />
            </el-input>
          </el-form-item>

          <div class="login-card__row">
            <el-checkbox v-model="loginForm.remenber">记住账号</el-checkbox>
            <a href="javascript:;" class="login-card__forgot" @click.prevent="onForgot">忘记密码</a>
          </div>

          <el-form-item class="login-card__submit-wrap">
            <el-button
              id="login"
              type="primary"
              class="login-card__submit"
              :loading="loading"
              @click="handleLogin"
            >
              {{ loading ? '登录中…' : '登录' }}
            </el-button>
          </el-form-item>

          <p class="login-card__copyright">
            Copyright © 20260423 {{ systemName || getSystemTitle() }} 版权所有
          </p>
        </el-form>
      </main>
    </div>

    <div class="el-login-footer">
      <span>博亚奇乐云 ylpiao.cn</span>
      <a
        href="http://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
      >
        闽ICP备2022011329号-4
      </a>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
/* eslint-disable */
import store from "@/store";
import config from '@/api/config'
export default {
  name: 'login',
  computed: {
    pageBackgroundStyle () {
      if (this.bgImage) {
        return { backgroundImage: this.bgImage }
      }
      return {}
    }
  },
  data () {
    return {
      yearDay:new Date().getFullYear(),
      loginLogo:'',
      bgImage:'',
      pingImgUrl:config.pingImgUrl,
      systemName:'',
      loading: false,
      itssusList:false,
      loginForm: {
        username: '',
        password: '',
        loginTissueId: '',
        remenber: false
      },
      options:[],
      fieldRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
      }
    }
  },
  mounted () {
    localStorage.languageName = '中文'
    localStorage.monitor = 'false'
    localStorage.stockIdWeight = ''
    localStorage.idProductionLineWeight = ''
    localStorage.arriveLoadometerNo = ''
    this.$api.login.getSysCompanyPage({code:'company'}).then(res => {
      if (res.code === 0 && res.data.list && res.data.list.length > 0) {
        this.loginLogo = res.data.list[0].loginLogo
        this.systemName = res.data.list[0].loginTitle?res.data.list[0].loginTitle:'管理平台'
        localStorage.loginName = res.data.list[0].loginName
        localStorage.loginTitle = res.data.list[0].loginTitle
        localStorage.indexName = res.data.list[0].indexName
        localStorage.loginLogo = res.data.list[0].loginLogo
        localStorage.indexImage = res.data.list[0].indexImage
        if (res.data.list[0].loginImage) {
          this.bgImage= "url('" + config.pingImgUrl + res.data.list[0].loginImage + "')"
        }
      }else{
        localStorage.loginName = ''
        localStorage.loginTitle = ''
        localStorage.indexName = ''
      }
    })
    this.$api.login.getSysCompanyPage({code:'localCurrency'}).then(res => {
      if (res.code === 0 && res.data.list && res.data.list.length > 0) {
        localStorage.amountUnit = res.data.list[0].indexName //金额单价单位
        localStorage.priceUnit = 2 //单价小数点res.data.list[0].loginLogo
        localStorage.numberUnit = res.data.list[0].loginTitle //数量小数点
      }else{
        localStorage.amountUnit = '元'
        localStorage.priceUnit = 2
        localStorage.numberUnit = 2
      }
    })
    this.restoreRememberedLogin()
  },
  methods: {
    restoreRememberedLogin () {
      try {
        if (localStorage.username) {
          this.loginForm.username = localStorage.username
          this.loginForm.remenber = true
        }
      } catch (e) { }
      // 安全策略：不回填密码
      this.loginForm.password = ''
      try { localStorage.password = '' } catch (e) { }
    },
    parseDateTimeLoose (s) {
      if (s === undefined || s === null) return null
      const str = String(s).trim()
      if (!str) return null
      // 兼容 "YYYY-MM-DD HH:mm:ss" 在部分浏览器下无法直接 new Date()
      const d = new Date(str.replace(/-/g, '/'))
      if (Number.isNaN(d.getTime())) return null
      return d
    },
    formatDateOnly (s) {
      if (s === undefined || s === null) return ''
      const str = String(s).trim()
      if (!str) return ''
      // 常见：2026-04-22 00:00:00 / 2026-04-22T00:00:00 / 2026/04/22 00:00:00
      const cut = str.split(' ')[0].split('T')[0]
      // 兜底：只保留前 10 位（YYYY-MM-DD 或 YYYY/MM/DD）
      return cut.length >= 10 ? cut.slice(0, 10) : cut
    },
    getCurrentTissueFromUser (user) {
      const tissueList = user && Array.isArray(user.tissueList) ? user.tissueList : []
      const loginTissueId = user && user.loginTissueId !== undefined && user.loginTissueId !== null
        ? String(user.loginTissueId)
        : ''
      if (!loginTissueId) return tissueList[0] || null
      return tissueList.find(it => it && it.id !== undefined && it.id !== null && String(it.id) === loginTissueId) || tissueList[0] || null
    },
    notifyIfTissueExpiringSoon (user) {
      const tissue = this.getCurrentTissueFromUser(user)
      const endStr = tissue && tissue.openEndDate !== undefined && tissue.openEndDate !== null ? String(tissue.openEndDate) : ''
      const end = this.parseDateTimeLoose(endStr)
      if (!end) return
      const endDateText = this.formatDateOnly(endStr)
      const now = new Date()
      const diffMs = end.getTime() - now.getTime()
      const diffDays = Math.ceil(diffMs / (24 * 60 * 60 * 1000))
      const tissueName = tissue && tissue.tissueName ? tissue.tissueName : (user && user.loginTissueName ? user.loginTissueName : '当前园区')

      if (diffDays <= 30) {
        if (diffDays < 0) {
          this.$notify({
            title: '到期提醒',
            type: 'error',
            position: 'top-right',
            duration: 5000,
            message: `${tissueName} 已到期（到期时间：${endDateText}），请联系管理员续费`
          })
        } else {
          this.$notify({
            title: '到期提醒',
            type: 'warning',
            position: 'top-right',
            duration: 5000,
            message: `${tissueName} 将在 ${diffDays} 天后到期（到期时间：${endDateText}），请及时续费`
          })
        }
      }
    },
    notifyIfNeedUpdatePassword (user) {
      if (!user) return
      const rawFlag = user.isUpdPwd
      const needUpdate = rawFlag === 0 || rawFlag === '0'
      if (needUpdate) {
        try {
          localStorage.needOpenPasswordDialog = '1'
        } catch (e) {}
      } else {
        try {
          localStorage.removeItem('needOpenPasswordDialog')
          localStorage.removeItem('forceOldPasswordHash')
        } catch (e) {}
      }
    },
    getRememberedTissue (username) {
      if (!username) return null
      try {
        const map = JSON.parse(localStorage.lastLoginTissueMap || '{}')
        const key = String(username).trim()
        if (map && map[key] && map[key].id !== undefined && map[key].id !== null && map[key].id !== '') {
          return {
            id: String(map[key].id),
            name: map[key].name ? String(map[key].name) : ''
          }
        }
      } catch (e) {}
      return null
    },
    saveRememberedTissue (username, tissueId, tissueName) {
      if (!username || tissueId === undefined || tissueId === null || tissueId === '') return
      try {
        const map = JSON.parse(localStorage.lastLoginTissueMap || '{}')
        map[String(username).trim()] = {
          id: String(tissueId),
          name: tissueName ? String(tissueName) : ''
        }
        localStorage.lastLoginTissueMap = JSON.stringify(map)
      } catch (e) {}
    },
    resolveWxMinProgramId (user) {
      if (!user) return ''
      const tissueList = Array.isArray(user.tissueList) ? user.tissueList : []
      const loginTissueId = user.loginTissueId !== undefined && user.loginTissueId !== null ? String(user.loginTissueId) : ''
      const current = tissueList.find(it => it && it.id !== undefined && it.id !== null && String(it.id) === loginTissueId)
      const fromTissue = current && current.wxMinProgramId !== undefined && current.wxMinProgramId !== null
        ? current.wxMinProgramId
        : ''
      const fromUser = user.wxMinProgramId !== undefined && user.wxMinProgramId !== null ? user.wxMinProgramId : ''
      const value = fromTissue !== '' ? fromTissue : fromUser
      return value === '' ? '' : String(value)
    },
    onForgot () {
      this.$message.info('请联系管理员重置密码')
    },
    getLogoImage() {
      return require('@/assets/images/boyo.png')
    },
    getSystemTitle() {
        return '游乐园系统'
    },
    getOptions(val) {
      this.options = []
      if(!val) return
      this.$api.user.getUserTissueList({username:val}).then(res => {//组织
        if (res.code == 0) {
          for(let i in res.data){
            this.options.push({ id: res.data[i].id, tissueName: res.data[i].tissueName})
          }
          const remembered = this.getRememberedTissue(val)
          if (remembered) {
            const matched = res.data.find(it => it && it.id !== undefined && it.id !== null && String(it.id) === remembered.id)
            if (matched) {
              this.loginForm.loginTissueId = matched.id
            }
          }
          if (!this.loginForm.loginTissueId && res.data.length == 1) {
            this.loginForm.loginTissueId = res.data[0].id
          }
        }else{
          this.$message({ message: '组织查询：'+res.msg, type: 'error' })
        }
      })
    },
    handleLogin () {
      this.$refs.loginForm.validate((val) => {
        if (val) {
          this.loading = true
          const data = JSON.parse(JSON.stringify(this.loginForm))
          if (data.password.length < 16) {
            data.password = md5.hex(data.password)
          }
          delete data.code
          delete data.remenber
          const remembered = this.getRememberedTissue(this.loginForm.username)
          if (data.loginTissueId !== undefined && data.loginTissueId !== null && data.loginTissueId !== '') {
            data.loginTissueId = String(data.loginTissueId)
          } else if (remembered && remembered.id) {
            data.loginTissueId = remembered.id
          } else {
            delete data.loginTissueId
          }
          this.$api.login.login(data).then(res => {
            this.loading = false
            if (res.code === 1) {
              this.$message({ message: res.msg, type: 'error' })
            }
            else if (res.code === 0) {
              this.loading = false
              // 记录本次登录口令哈希：强制改密场景下接口仍需 oldPassword 时复用
              try {
                localStorage.forceOldPasswordHash = data.password || ''
              } catch (e) {}
              console.log('[login] sysUser:', (res && res.data) ? res.data.user : undefined)
              console.log('[login] sysUser.isUpdPwd:', (res && res.data && res.data.user) ? res.data.user.isUpdPwd : undefined)
              // 登录时提示当前园区到期情况（<=30天提示；已过期也提示）
              this.notifyIfTissueExpiringSoon(res && res.data ? res.data.user : null)
              // 登录后如仍为初始密码，提示尽快修改
              this.notifyIfNeedUpdatePassword(res && res.data ? res.data.user : null)
              this.$store.commit('online', true)
              this.$store.commit('RouterLoad', false)
              this.$store.commit('menuList', [])
              this.$store.commit('updateTabList', [])
              this.$store.commit('updateActiveTab', '')
              this.$localStorage.set('token', res.data.token, 168)
              localStorage.roleId = (res.data.user.roleIdList && res.data.user.roleIdList.length>0)?res.data.user.roleIdList[0]:''
              localStorage.userId = res.data.user.userId
              localStorage.nickName = res.data.user.nickName
              localStorage.employeeId = res.data.user.employeeId
              localStorage.employeeName = res.data.user.employeeName
              localStorage.personal = JSON.stringify(res.data.user)
              localStorage.loginTissueId = res.data.user.loginTissueId
              localStorage.loginTissueName = res.data.user.loginTissueName
              localStorage.tissueIds = res.data.user.tissueIds || ''
              this.saveRememberedTissue(this.loginForm.username, res.data.user.loginTissueId, res.data.user.loginTissueName)
              localStorage.wxMinProgramId = this.resolveWxMinProgramId(res.data.user)
              localStorage.roleIdList = res.data.user.roleIdList
              const currentTissue = this.getCurrentTissueFromUser(res.data.user)
              localStorage.openEndDate = currentTissue && currentTissue.openEndDate ? currentTissue.openEndDate : ''
              localStorage.menuNameActive = ''
              if (this.companyType && this.companyType.length > 0) {
                localStorage.companyType = JSON.stringify(this.companyType)
                const companyTypeObjects = this.companyTypeOptions.filter(item =>
                  this.companyType.includes(item.companyName)
                )
                localStorage.companyTypeObjects = JSON.stringify(companyTypeObjects)
                localStorage.companyTypeIds = JSON.stringify(companyTypeObjects.map(item => item.factoryAreaId))
              } else {
                localStorage.companyType = ''
                localStorage.companyTypeObjects = ''
                localStorage.companyTypeIds = ''
              }
              this.$message({ message: res.msg, type: 'success' })
              if (this.loginForm.remenber) {
                try {
                  localStorage.username = this.loginForm.username
                  localStorage.password = ''
                } catch (e) { }
              }
              else {
                try {
                  localStorage.username = ''
                  localStorage.password = ''
                } catch (e) { }
              }
              this.$router.push('/index')
            }
          }, err => {
            this.loading = false
          })
        }
      })
    },
    removeImage(file, fileList, fieldName) {
    console.log('删除图片:', file, fieldName);

    if (this.dialogInfo.visible) {
      this.formInfo.data[fieldName] = '';

      this.formInfo.list.forEach(item => {
        if (item.value === fieldName && item.fileListHt) {
          item.fileListHt = item.fileListHt.filter(f => f.uid !== file.uid);
        }
      });

    } else if (this.dialogInfo1.visible) {
      this.formInfo1.data[fieldName] = '';

      this.formInfo1.list.forEach(item => {
        if (item.value === fieldName && item.fileListHt) {
          item.fileListHt = item.fileListHt.filter(f => f.uid !== file.uid);
        }
      });
    }

    this.$message({
      message: '图片删除成功',
      type: 'success'
    });
  }
  },
  watch: {
  }
}
</script>
<style lang="stylus" scoped>
$text = #1a1a1a
$muted = #3d6a8c
$input-bg = #e8f3ff
$accent = #2d8fd0
$accent-deep = #1c7bb8

.login
  height 100%
  width 100%
  min-height 100vh
  box-sizing border-box
  /* 登录页独立变量 --login-canvas-*（主壳为黑色主题 --layout-canvas-*） */
  background-color var(--login-canvas-bg, #061018)
  background-image var(--login-canvas-gradient)
  background-size cover
  background-position center
  background-repeat no-repeat
  background-attachment fixed
  position relative
  font-family "PingFang SC","Microsoft YaHei","微软雅黑",system-ui,sans-serif

/* 轻纱统一对比度，压一点高光 */
.login__veil
  position fixed
  inset 0
  z-index 0
  pointer-events none
  background linear-gradient(118deg, rgba(8, 40, 72, 0.35) 0%, transparent 45%, rgba(20, 60, 100, 0.2) 100%)

.login-page
  position relative
  z-index 1
  display flex
  min-height 100vh
  align-items stretch

.login-brand
  flex 1 1 54%
  min-width 0
  min-height 320px
  position relative
  display flex
  align-items center
  padding 48px 56px 80px

.login-brand__overlay
  position absolute
  left 0
  top 0
  bottom 0
  width 62%
  max-width 720px
  z-index 0
  background linear-gradient(100deg, rgba(6, 24, 44, 0.72) 0%, rgba(12, 48, 86, 0.35) 52%, transparent 100%)
  pointer-events none

.login-brand__content
  position relative
  z-index 1
  max-width 520px

.login-brand__title
  margin 0
  font-size clamp(28px, 4vw, 40px)
  font-weight 700
  color #fff
  letter-spacing 0.02em
  line-height 1.25
  text-shadow 0 2px 20px rgba(20, 100, 180, 0.4)

.login-brand__subtitle
  margin 12px 0 0
  font-size 15px
  color rgba(255, 255, 255, 0.95)
  text-shadow 0 1px 10px rgba(20, 100, 180, 0.35)

.login-panel
  flex 0 0 46%
  max-width 720px
  display flex
  align-items center
  justify-content center
  padding 40px 52px 68px
  box-sizing border-box
  position relative
  /* 登录区背后柔光，让白卡片从动效/渐变背景里浮出来 */
  &::before
    content ''
    position absolute
    z-index 0
    width min(92%, 600px)
    aspect-ratio 1
    max-height 90vh
    border-radius 50%
    background radial-gradient(circle, rgba(45, 143, 208, 0.22) 0%, rgba(45, 143, 208, 0.06) 45%, transparent 70%)
    filter blur(2px)
    pointer-events none
    top 50%
    left 50%
    transform translate(-50%, -50%)

.login-card
  position relative
  z-index 1
  width 100%
  max-width 540px
  margin 0 auto
  padding 52px 56px 42px
  background #fff
  border-radius 20px
  /* 双层描边 + 深阴影，突出登录窗口 */
  box-shadow 0 0 0 1px rgba(255, 255, 255, 0.95), 0 0 0 6px rgba(45, 143, 208, 0.14), 0 24px 56px rgba(15, 55, 95, 0.35), 0 8px 24px rgba(29, 122, 200, 0.22)
  box-sizing border-box

.login-card__head
  display flex
  align-items flex-start
  justify-content flex-start
  margin-bottom 36px
  gap 16px

.login-card__brand
  display flex
  flex-wrap wrap
  align-items center
  gap 8px

.login-card__logo
  height 40px
  width auto
  object-fit contain

.login-card__name
  font-size 26px
  font-weight 700
  color $accent

.login-field
  margin-bottom 20px
  >>> .el-form-item__content
    line-height normal
  >>> .el-form-item__error
    padding-top 4px

.login-input-wrap
  position relative
  width 100%

.login-field__icon--select
  position absolute
  left 14px
  top 50%
  transform translateY(-50%)
  z-index 2
  pointer-events none
  line-height 1
  margin 0

.login-field__icon
  color #3d8cc9
  font-size 19px
  line-height 54px
  margin-left 4px

.login-select-block
  width 100%
  >>> .el-input__inner
    padding-left 44px !important

.login-card__row
  display flex
  align-items center
  justify-content space-between
  margin-bottom 12px
  font-size 15px
  >>> .el-checkbox__label
    color $muted

.login-card__forgot
  color $muted
  text-decoration none
  &:hover
    color $accent

.login-card__submit-wrap
  margin-bottom 12px
  margin-top 8px

/* hover 勿改 background 为纯色：Element 默认 hover 背景 + 渐变与纯色互切会闪；用同一条渐变 + filter 过渡 */
.login-card__submit
  width 100%
  height 56px
  font-size 19px
  font-weight 600
  letter-spacing 0.2em
  border-radius 12px
  border-color transparent !important
  color #fff !important
  background linear-gradient(180deg, $accent 0%, $accent-deep 100%) !important
  box-shadow 0 2px 8px rgba(28, 123, 184, 0.25)
  transition filter 0.22s ease, box-shadow 0.22s ease, opacity 0.18s ease !important
  &:hover, &:focus
    color #fff !important
    border-color transparent !important
    background linear-gradient(180deg, $accent 0%, $accent-deep 100%) !important
    filter brightness(0.94)
    box-shadow 0 4px 16px rgba(28, 123, 184, 0.35)
  &:active
    filter brightness(0.88)
    box-shadow 0 2px 8px rgba(28, 123, 184, 0.3)
  &.is-loading, &.is-loading:hover, &.is-loading:focus
    filter none
    background linear-gradient(180deg, $accent 0%, $accent-deep 100%) !important
    border-color transparent !important

.login-card__copyright
  margin 26px 0 0
  text-align center
  font-size 13px
  color #4e7aa8
  line-height 1.5

.login-card
  >>> .el-input__inner
    height 54px
    line-height 54px
    font-size 16px !important
    background $input-bg !important
    border none !important
    border-radius 12px !important
    color $text !important
    padding-left 44px !important
    &::placeholder
      color #6a9ec9
      font-size 16px
  >>> .el-input__prefix
    left 14px
  >>> .el-form-item__error
    font-size 13px
  >>> .el-form-item.is-error .el-input__inner
    box-shadow 0 0 0 1px #f56c6c inset

.login-card
  >>> .el-select
    width 100%
  >>> .el-select .el-input__inner
    padding-left 44px !important

@media screen and (max-width 960px)
  .login-page
    flex-direction column
  .login-brand
    flex none
    padding 32px 24px 36px
    min-height 260px
    background-position center
  .login-panel
    flex none
    max-width none
    width 100%
    padding 16px 20px 48px
  .login-card
    max-width 580px

.el-login-footer
  position fixed
  bottom 0
  left 0
  right 0
  z-index 2
  text-align center
  padding 10px 16px 14px
  box-sizing border-box
  font-family "Source Han Sans SC","思源黑体","PingFang SC","Microsoft YaHei",sans-serif
  font-size 13px
  line-height 1.5
  letter-spacing 0.3px
  color rgba(255, 255, 255, 0.95)
  background linear-gradient(to top, rgba(8, 28, 52, 0.88) 0%, rgba(8, 28, 52, 0.72) 55%, rgba(8, 28, 52, 0) 100%)
  text-shadow 0 1px 2px rgba(0, 0, 0, 0.45)
  pointer-events none
  span
    margin-right 8px
  a
    color rgba(255, 255, 255, 0.95)
    text-decoration none
    &:hover
      text-decoration underline
    pointer-events auto

@media screen and (max-height 450px)
  .el-login-footer
    display none
</style>



// WEBPACK FOOTER //
// src/views/login.vue